/**
 * 函数的防抖
 */

export function debounce(fn, delay) { 
  var timer = null;
  var delay = delay || 1000;
  return function () {
    var _self = this; // 这里的this是Vue
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(_self);
    }, delay);
  };
}

/**
 * @param {function} handler // 事件处理函数
 * @param {Number} wait  // 事件指向的事件间隔
 */
export const Throttle = (fn, t = 5000) => {
  let last;
  let timer;
  let interval = t;
  return function () {
    let args = arguments;
    let now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, interval);
    } else {
      last = now;
      fn.apply(this, args);
    }
  }
};

export function filterObj(obj, arr) {
  if (typeof (obj) !== "object" || !Array.isArray(arr)) {
    throw new Error("参数格式不正确")
  }
  const result = {}
  Object.keys(obj).filter((key) => arr.includes(key)).forEach((key) => {
    result[key] = obj[key]
  })
  return result
}

